import { Navigation } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface DirectionsLinkProps {
  lat: number;
  lng: number;
  name?: string;
  className?: string;
  variant?: "default" | "outline" | "secondary" | "ghost";
  size?: "default" | "sm" | "lg" | "icon";
  label?: string;
}

export function DirectionsLink({
  lat,
  lng,
  name,
  className,
  variant = "outline",
  size = "sm",
  label = "Get directions",
}: DirectionsLinkProps) {
  const href = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}${
    name ? `&destination_name=${encodeURIComponent(name)}` : ""
  }`;
  return (
    <Button
      asChild
      variant={variant}
      size={size}
      className={cn("min-h-11 gap-2", className)}
      onClick={(e) => e.stopPropagation()}
    >
      <a href={href} target="_blank" rel="noopener noreferrer">
        <Navigation className="h-4 w-4" />
        {label}
      </a>
    </Button>
  );
}
